exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fmcy-order-items.row-flex {\n  margin-left: 0;\n  margin-right: 0; }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./assets/js/common/orders/order-items/order-items.scss
 ** module id = 550
 ** module chunks = 1 86 105 112
 **/